import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import * as yup from "yup";
import BaseButton from "Components/Base/BaseButton";
import { BaseSelect } from "Components/Base/BaseSelect";
import {
  checkStatusCodeSuccess,
  errorHandler,
  notFound,
} from "Components/constants/Common";
import { NewLabel } from "Components/constants/PartsIssueDetails";
import { useFormik } from "formik";
import { NoLabel, submitLabel, YesLabel } from "Components/constants/Role";
import { getRONumberList } from "Api/RepairOrderOpen";
import { toast } from "react-toastify";
import {
  EditPrLabel,
  PartRequiaitionLabel,
} from "Components/constants/PurchaseOrder";
import {
  addOrEditPR,
  deletePR,
  editPRWORO,
  getViewPR,
  getViewPRWORO,
  listOfItemCode,
  listOfProductForItem,
  listOfProject,
} from "Api/PartRequisition";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import DeleteModal from "Components/Base/DeleteModal";
import Loader from "Components/Base/BaseLoader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ACTION_LABEL,
  ADD_NEW_MAKE,
  ITEM_CODE_LABEL,
  MAKE_LABEL,
  MAKE_NAME,
  MATERIAL_GRP_DESC_LABEL,
  MATERIAL_GRP_LABEL,
  MATERIAL_TYPE_LABEL,
  PARTS_NAME_LABEL,
  PLEASE_ENTER_PROD_DETAILS_FOR_NEW_ROW,
  PRODUCT_DELETE_SUCCESS,
  PROJECT_NAME_IS_REQUIRED_VALIDATION,
  PROJECT_NAME_LABEL,
  QTY_GREATER_THAN_ZERO,
  RACK_LOCA_LABEL,
  REQUESTED_QTY_IS_REQUIRED_VALIDATION,
  REQUESTED_QTY_LABEL,
  RO_NO_LABEL,
  SELECT_ITEM_CODE,
  SR_NO_LABEL,
  STOCK_LABEL,
  STORE_LOCA_LABEL,
  TEXT_DOCUMENT_OR_REMARKS,
  UOM_LABEL,
} from "Components/constants/ROModule";
import BaseModal from "Components/Base/BaseModal";
import {
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import { addMakeLabel } from "Components/constants/ManuFacturer";
import { createManufacturer, listOfManufacturer } from "Api/ManuFacturer";
import BaseInput from "Components/Base/BaseInput";
import { Column } from "ag-grid-community";
import Select from "react-select";

const ItemCodeEditor = ({ params }: { params: any }) => {
  const itemCodes = params.itemCodes || [];

  const formattedItemCodes = itemCodes.map((item: any) => {
    if (typeof item === "object" && item.value && item.label) {
      return item;
    }

    if (typeof item === "object" && item.value) {
      return {
        value: String(item.value),
        label: String(item.value),
      };
    }

    return {
      value: String(item),
      label: String(item),
    };
  });

  const handleChange = (selectedOption: any) => {
    params.stopEditing();

    if (!selectedOption) {
      const resetData = {
        ...params.data,
        tempId: params.data.tempId,
        srNo: params.data.srNo,
        item_code: "",
        parts_name: "",
        uom: "",
        stock: "",
        make: "",
        manufacturer_id: null,
        product_variant_id: null,
        product_id: null,
        material_type: "",
        material_group: "",
        material_group_description: "",
        store_location: "",
        rack_location: "",
        qty: "",
        project_name: "",
        remarks: "",
      };

      if (params.context.updateRowData) {
        params.context.updateRowData(params.rowIndex, resetData);
      }

      params.api.applyTransaction({
        update: [resetData],
      });

      return;
    }

    const optionValue = selectedOption?.value ?? "";
    let label = selectedOption?.label ?? "";
    let id = optionValue;

    if (typeof optionValue === "string" && optionValue.includes("|")) {
      const parts = optionValue.split("|");
      label = parts[0];
      id = parts[1] || label;
    }

    params.node.setDataValue("item_code", label);
    params.context.handleProductSelect(label, params.rowIndex, Number(id));
  };

  const selectedItemCode = formattedItemCodes.find(
    (item: { value: string; label: string }) => item.label === params.value
  );

  return (
    <Select
      name="item_code"
      options={formattedItemCodes}
      value={selectedItemCode || null}
      onChange={handleChange}
      placeholder={SELECT_ITEM_CODE}
      menuPosition="fixed"
      menuPlacement="auto"
      isClearable={true}
      styles={{
        control: (provided: any) => ({
          ...provided,
          width: "180px",
        }),
        menu: (provided: any) => ({
          ...provided,
          width: "180px",
        }),
      }}
    />
  );
};

const PartRequisition = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [viewPR, setViewPR] = useState<any[]>([]);
  const [selectedRONo, setSelectedRONo] = useState<any | null>(null);
  const [btnLoader, setBtnLoader] = useState(false);
  const [RONumberList, setRONumberList] = useState<any[]>([]);
  const [itemCodes, setItemCodes] = useState<any[]>([]);
  const [projectNames, setProjectNames] = useState<any[]>([]);
  const gridRef = useRef<AgGridReact<any>>(null);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [deleteRowData, setDeleteRowData] = useState<any>(null);
  const location = useLocation();
  const isPRRoute = location.pathname.includes("partRequisitionWORo");
  const isViewPRRoute = location.pathname.includes("editPartRequisitionWORo");
  const navigate = useNavigate();
  const { id } = useParams();
  const [makeOption, setMakeOption] = useState<Array<any>>([]);
  const [makeModal, setMakeModal] = useState<boolean>(false);
  const [modalLoader, setModalLoader] = useState<boolean>(false);
  const ro = !isPRRoute && !isViewPRRoute && id && location.state.ro;

  let validationSchema = yup.object();
  if (!isPRRoute && !isViewPRRoute) {
    validationSchema = validationSchema.shape({
      RONumber: yup.string().required(validationMessages.required(RO_NO_LABEL)),
    });
  }

  const handleCellKeyDown = (event: any) => {
    if (event.event.key === "Enter") {
      const { node, column } = event;
      const gridApi = gridRef.current?.api;
      const columnDefs = gridApi?.getColumns() || [];
      const lastColumnIndex = columnDefs.length - 1;

      if (column === columnDefs[lastColumnIndex]) {
        if (node.rowIndex === viewPR.length - 1) {
          handleAddProduct();
          setTimeout(() => {
            const firstEditableColumn = columnDefs.find(
              (col: Column) => col.getColDef().editable
            );
            if (firstEditableColumn) {
              gridApi?.startEditingCell({
                rowIndex: node.rowIndex + 1,
                colKey: firstEditableColumn.getColId(),
              });
            }
          }, 100);
        } else {
          const nextRowIndex = node.rowIndex + 1;
          const firstEditableColumn = columnDefs.find(
            (col: Column) => col.getColDef().editable
          );
          if (firstEditableColumn) {
            gridApi?.startEditingCell({
              rowIndex: nextRowIndex,
              colKey: firstEditableColumn.getColId(),
            });
          }
        }
      }
    }
  };

  const fetchRODetailsById = (ro_id: number, isExcludePo: boolean) => {
    setLoader(true);
    getViewPR({ ro_id, isExcludePo })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;

          if (Array.isArray(data) && data.length > 0) {
            const allItems = data.flatMap(
              (item) => item.partRequisitionItem || []
            );

            const formattedData = allItems.map((item, index) => ({
              srNo: index + 1,
              id: item.id,
              ro_id: item.ro_id,
              make: item.productVariant?.manufacturer?.name || "",
              manufacturer_id: item.productVariant?.manufacturer_id || "",
              product_variant_id: item.productVariant?.id || null,
              product_id: item.product_id || null,
              item_code: item.item_code || "",
              parts_name: item.parts_name || "",
              uom: item.uom || "",
              qty: item.qty || "",
              stock: item.productVariant?.quantity || 0,
              store_location: item.store_location || "",
              project_name: item.project_name || "",
              rack_location: item.rack_location || "",
              remarks: item.remarks || "",
              material_type: item.material_type || "",
              material_group: item.material_group || "",
              material_group_description: item.material_group_description || "",
              isExcludePo: false,
            }));

            const totalRowsNeeded = 11;
            const actualDataRows = formattedData.length;
            const emptyRowsNeeded = Math.max(
              0,
              totalRowsNeeded - actualDataRows
            );

            const emptyRows = Array.from({ length: emptyRowsNeeded }, () =>
              createEmptyRow()
            );

            const finalData = [...formattedData, ...emptyRows];
            setViewPR(finalData);
          } else {
            const initialRows = Array.from({ length: 11 }, () =>
              createEmptyRow()
            );
            setViewPR(initialRows);
          }
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoader(false);
      });
  };

  const fetchPRDetailsById = (part_id: number, isExcludePo: boolean) => {
    setLoader(true);
    getViewPRWORO({ part_id, isExcludePo })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;

          if (Array.isArray(data) && data.length > 0) {
            const allItems = data.flatMap(
              (item) => item.partRequisitionItem || []
            );

            const formattedData = allItems.map((item, index) => ({
              srNo: index + 1,
              id: item.id,
              make: item.productVariant?.manufacturer?.name || "",
              item_id: item.id,
              product_id: item.product_id || null,
              item_code: item.productVariant?.product?.product_code || "",
              parts_name: item.parts_name || "",
              uom: item.uom || "",
              qty: item.qty || "",
              stock: item.productVariant?.quantity || 0,
              store_location: item.store_location || "",
              project_name: item.project?.project_name || "",
              rack_location: item.rack_location || "",
              remarks: item.remarks || "",
              material_type: item.material_type || "",
              manufacturer_id: item.productVariant?.manufacturer_id || "",
              product_variant_id: item.productVariant?.id || null,
              material_group: item.material_group || "",
              material_group_description: item.material_group_description || "",
              isExcludePo: true,
            }));

            setViewPR(formattedData);
          } else {
            setViewPR([]);
          }
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (isViewPRRoute && id) {
      fetchPRDetailsById(Number(id), true);
    }
  }, [isViewPRRoute, id]);

  useEffect(() => {
    listOfProject()
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data?.project;
          setProjectNames(
            data.map((item: any) => ({
              value: item.id,
              label: item.project_name,
            }))
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      });
  }, []);

  useEffect(() => {
    getRONumberList()
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;
          setRONumberList(
            data.map((item: any) => ({
              label: item.ro_no,
              value: item.id,
            }))
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      });
  }, []);

  useEffect(() => {
    listOfItemCode({})
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data?.product;
          const formattedItemCodes = data.map((item: any) => ({
            value: item.id,
            label: item.productName,
          }));
          setItemCodes(formattedItemCodes);
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      });
  }, []);

  const createEmptyRow = useCallback(() => {
    const tempId = `temp-${Date.now()}-${Math.random()}`;
    return {
      tempId,
      srNo: "",
      item_code: "",
      parts_name: "",
      uom: "",
      qty: "",
      stock: "",
      store_location: "",
      project_id: "",
      rack_location: "",
      remarks: "",
      material_type: "",
      material_group: "",
      material_group_description: "",
    };
  }, []);

  const handleAddProduct = () => {
    const newRow = createEmptyRow();
    setViewPR((prevData) => [...prevData, newRow]);
  };

  useEffect(() => {
    if (!isViewPRRoute && !id) {
      const initialRows = Array.from({ length: 11 }, () => createEmptyRow());
      setViewPR(initialRows);
    }
  }, [isViewPRRoute, id, createEmptyRow]);

  const fetchMake = async () => {
    setLoader(true);
    try {
      const res = await listOfManufacturer({});
      if (checkStatusCodeSuccess(res?.statusCode)) {
        const data = res?.data?.manufacturers?.map((item: any) => ({
          value: item?.id,
          label: item?.name,
          id: item?.id,
        }));
        data.push({ value: "add_new", label: ADD_NEW_MAKE, id: "add_new" });
        setMakeOption(data);
      } else {
        setMakeOption([
          { value: "add_new", label: ADD_NEW_MAKE, id: "add_new" },
        ]);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err?.message);
      setMakeOption([{ value: "add_new", label: ADD_NEW_MAKE, id: "add_new" }]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchMake();
  }, []);

  const makeForm = useFormik({
    initialValues: {
      name: "",
    },
    onSubmit: async (values) => {
      setModalLoader(true);

      const payload = {
        name: values.name,
      };
      createManufacturer(payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            setMakeModal(false);
            fetchMake();
            makeForm.resetForm();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
        })
        .finally(() => setModalLoader(false));
    },
  });

  const handleProductSelect = async (
    productCode: string,
    rowIndex: number,
    selectedId: number
  ) => {
    try {
      const response = await listOfProductForItem({
        product_id: selectedId,
      });

      if (response?.statusCode === 200 && response.data?.[0]) {
        const productDetails = response.data[0];

        setViewPR((prevData) => {
          const updatedData = [...prevData];
          const existingRow = updatedData[rowIndex];
          updatedData[rowIndex] = {
            ...existingRow,
            id: existingRow?.id || null,
            product_id: selectedId,
            make: productDetails.productVariant?.[0]?.manufacturer?.name || "",
            product_variant_id: productDetails.productVariant?.[0]?.id || null,
            manufacturer_id:
              productDetails.productVariant?.[0]?.manufacturer_id || "",
            parts_name: productDetails.product_description,
            uom: productDetails.productUom?.uom || "",
            stock: productDetails.productVariant?.[0]?.quantity || 0,
            material_type: productDetails.material?.name || "",
            material_group: productDetails.materialGroup?.name || "",
            material_group_description:
              productDetails.material_group_description || "",
            store_location: productDetails.store?.storeAddress?.address || "",
            rack_location: productDetails.rake_no || "",
          };
          return updatedData;
        });
      } else {
        toast.error(response?.message);
      }
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  const updateRowData = (rowIndex: number, newData: any) => {
    setViewPR((prevData) => {
      const newArray = [...prevData];
      newArray[rowIndex] = newData;
      return newArray;
    });
  };

  const PartRequisitionColumns = useMemo(
    () => [
      {
        headerName: SR_NO_LABEL,
        field: "srNo",
        valueGetter: "node.rowIndex + 1",
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: ITEM_CODE_LABEL,
        field: "item_code",
        editable: true,
        flex: 1.5,
        minWidth: 180,
        sortable: true,
        cellEditor: (params: any) => {
          return (
            <ItemCodeEditor
              params={{
                ...params,
                itemCodes,
                context: {
                  handleProductSelect,
                  updateRowData,
                },
              }}
            />
          );
        },
        cellEditorPopup: true,
        valueFormatter: (params: { value: string }) => {
          return params.value || "";
        },
      },
      {
        headerName: REQUESTED_QTY_LABEL,
        field: "qty",
        editable: true,
        flex: 1.5,
        headerClass: "required",
        minWidth: 150,
        valueParser: (params: any) => {
          const value = params.newValue;
          return value ? parseFloat(value) : 0;
        },
      },
      {
        headerName: STOCK_LABEL,
        field: "stock",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
        valueParser: (params: any) => {
          const value = params.newValue;
          return value ? parseFloat(value) : 0;
        },
      },
      {
        headerName: MAKE_LABEL,
        field: "make",
        editable: true,
        flex: 1.5,
        minWidth: 150,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: makeOption?.map(
            (option: any) => `${option?.label}|${option?.id}`
          ),
        },
        valueFormatter: (params: { value: string }) => {
          if (!params.value) return "";
          return params.value.split("|")[0];
        },
        valueSetter: (params: any) => {
          const [label, id] = params.newValue.split("|");
          if (label === ADD_NEW_MAKE) {
            setMakeModal(true);
            return false;
          }

          params.data.make = label;
          params.data.manufacturer_id = Number(id);
          return true;
        },
      },
      {
        headerName: PARTS_NAME_LABEL,
        field: "parts_name",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
      },
      {
        headerName: UOM_LABEL,
        field: "uom",
        editable: false,
        flex: 1.5,
        minWidth: 150,
        sortable: true,
      },
      {
        headerName: STORE_LOCA_LABEL,
        field: "store_location",
        editable: true,
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: PROJECT_NAME_LABEL,
        headerTooltip: PROJECT_NAME_LABEL,
        field: "project_name",
        tooltipField: "project_name",
        editable: true,
        headerClass: "required",
        sortable: true,
        flex: 1.5,
        minWidth: 150,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: projectNames.map((item) => item.label),
          valueField: "value",
          displayField: "label",
        },
        valueSetter: (params: any) => {
          const selectedProject = projectNames.find(
            (item) => item.label === params.newValue
          );
          if (selectedProject) {
            params.data.project_name = selectedProject.label;
            params.data.project_id = selectedProject.value;
            return true;
          }
          params.data.project_name = "";
          params.data.project_id = null;
          return true;
        },
      },
      {
        headerName: RACK_LOCA_LABEL,
        field: "rack_location",
        editable: true,
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: TEXT_DOCUMENT_OR_REMARKS,
        field: "remarks",
        editable: true,
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: MATERIAL_TYPE_LABEL,
        field: "material_type",
        editable: false,
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: MATERIAL_GRP_LABEL,
        field: "material_group",
        editable: false,
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: MATERIAL_GRP_DESC_LABEL,
        field: "material_group_description",
        editable: false,
        flex: 1.5,
        minWidth: 150,
      },
      {
        headerName: ACTION_LABEL,
        filter: false,
        flex: 1.5,
        minWidth: 150,
        cellRenderer: (params: any) => (
          <span>
            <i
              className="mdi mdi-delete-outline fs-4 text-danger cursor-pointer"
              onClick={() => handleDeleteProduct(params.data)}
            ></i>
          </span>
        ),
      },
    ],
    [itemCodes, projectNames, makeOption]
  );

  const handleDeleteProduct = (rowData: any) => {
    setDeleteRowData(rowData);
    setDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
    setDeleteRowData(null);
  };

  const handleDeleteConfirmation = () => {
    if (deleteRowData) {
      setLoader(true);
      if (!deleteRowData.id) {
        setViewPR((prevData) =>
          prevData.filter((row) => row.tempId !== deleteRowData.tempId)
        );
        toast.success(PRODUCT_DELETE_SUCCESS);
      } else {
        deletePR(deleteRowData.id)
          .then(() => {
            setViewPR((prevData) =>
              prevData.filter((row) => row.id !== deleteRowData.id)
            );
            toast.success(PRODUCT_DELETE_SUCCESS);
          })
          .catch((err) =>
            toast.error(err?.response?.data?.message || err?.message)
          );
      }
      setLoader(false);
      setDeleteModal(false);
    }
  };

  const handleSubmit = async (values: any) => {
    if (!viewPR || viewPR.length === 0) {
      return;
    }

    const rowsWithData = viewPR.filter(
      (row) => row.item_code && row.parts_name
    );

    if (rowsWithData.length === 0) {
      toast.error(PLEASE_ENTER_PROD_DETAILS_FOR_NEW_ROW);
      return;
    }

    const emptyQtyRow = rowsWithData.some(
      (row) => row.qty === "" || row.qty === undefined || row.qty === null
    );

    if (emptyQtyRow) {
      toast.error(REQUESTED_QTY_IS_REQUIRED_VALIDATION);
      return;
    }

    const invalidQtyRow = rowsWithData.some((row) => {
      const qty = Number(row.qty);
      return isNaN(qty) || qty <= 0;
    });

    if (invalidQtyRow) {
      toast.error(QTY_GREATER_THAN_ZERO);
      return;
    }

    const emptyProjectNameRow = rowsWithData.some(
      (row) => row.project_name === "" || row.project_name === undefined || row.project_name === null
    );

    if (emptyProjectNameRow) {
      toast.error(PROJECT_NAME_IS_REQUIRED_VALIDATION);
      return;
    }

    const payload = {
      repair_order_id: Number(selectedRONo),
      part_id: Number(id),
      product: rowsWithData.map((row) => ({
        id: row.id,
        product_variant_id: row.product_variant_id,
        manufacturer_id: row.manufacturer_id || null,
        product_id: Number(row.product_id),
        item_code: row.item_code,
        qty: Number(row.qty),
        project_id: row.project_id || null,
        remarks: row.remarks || "",
        parts_name: row.parts_name,
        uom: row.uom,
        stock: row.stock,
        store_location: row.store_location,
        rack_location: row.rack_location,
        material_type: row.material_type,
        material_group: row.material_group,
        material_group_description: row.material_group_description,
      })),
    };

    if (id) {
      setBtnLoader(true);
      editPRWORO(Number(id), payload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            if (isPRRoute) {
              navigate("/indentation");
            } else if (isViewPRRoute) {
              navigate("/indentation");
            } else {
              navigate("/partRequisition");
            }
          } else {
            toast.error(res?.message);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || err?.message);
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      try {
        setBtnLoader(true);
        const response = await addOrEditPR(payload);

        if (checkStatusCodeSuccess(response?.statusCode)) {
          toast.success(response.message);
          fetchRODetailsById(selectedRONo, true);
          if (isPRRoute) {
            navigate("/indentation");
          } else if (isViewPRRoute) {
            navigate("/indentation");
          } else {
            navigate("/partRequisition");
          }
        } else {
          toast.error(response.message);
        }
      } catch (err: any) {
        errorHandler(err);
        toast.error(err?.response?.data?.message || err?.message);
      } finally {
        setBtnLoader(false);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      RONumber: id ? ro : "",
      qty: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleRONumberChange = (value: any) => {
    setSelectedRONo(value);
    if (value) {
      fetchRODetailsById(value, false);
    } else {
      const initialRows = Array.from({ length: 11 }, () => createEmptyRow());
      setViewPR(initialRows);
    }
  };

  useEffect(() => {
    if (id) {
      handleRONumberChange(Number(ro));
    } else if (!isViewPRRoute) {
      const initialRows = Array.from({ length: 11 }, () => createEmptyRow());
      setViewPR(initialRows);
    }
  }, [id, isViewPRRoute]);

  return (
    <div className="page-content">
      {loader && <Loader />}
      <div className="flex-grow-1 mx-3">
        <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
          <span className="fs-4 d-flex gap-4">
            {id ? EditPrLabel : PartRequiaitionLabel}
          </span>
          <BaseButton
            color="danger"
            onClick={() =>
              isPRRoute || isViewPRRoute
                ? navigate("/indentation")
                : navigate("/partRequisition")
            }
          >
            <i className="mdi mdi-arrow-left" />
          </BaseButton>
        </div>
        <div className="card word-wrap">
          <div className="card-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                {!isPRRoute && !isViewPRRoute && (
                  <div className="col-md-3 col-sm-6 col-12 mb-4">
                    <BaseSelect
                      name="RONumber"
                      label={RO_NO_LABEL}
                      options={RONumberList}
                      value={formik.values.RONumber}
                      handleChange={(field: any, value: any) => {
                        formik.setFieldValue(field, value);
                        handleRONumberChange(value);
                      }}
                      handleBlur={formik.handleBlur}
                      error={formik.errors.RONumber}
                      touched={formik.touched.RONumber}
                      isDisabled={id ? true : false}
                      required
                    />
                  </div>
                )}

                {isPRRoute || isViewPRRoute ? (
                  <div className="col-12 mb-2 d-flex justify-content-end">
                    <BaseButton
                      type="button"
                      className="btn btn-danger"
                      onClick={handleAddProduct}
                      children={NewLabel}
                    />
                  </div>
                ) : (
                  <div className="col-md-3 col-sm-6 col-12 mt-4">
                    <BaseButton
                      type="button"
                      className="btn btn-danger"
                      onClick={handleAddProduct}
                      children={NewLabel}
                    />
                  </div>
                )}
              </div>

              <div className="table-css">
                <div className="ag-theme-quartz">
                  <AgGridReact
                    ref={gridRef}
                    rowData={viewPR}
                    columnDefs={PartRequisitionColumns}
                    defaultColDef={{
                      sortable: true,
                      resizable: true,
                      flex: 1,
                      tooltipComponentParams: {
                        color: "blue",
                      },
                    }}
                    onCellKeyDown={handleCellKeyDown}
                    domLayout="normal"
                    getRowHeight={() => 35}
                    overlayNoRowsTemplate={notFound.dataNotFound}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end mb-1 mt-4 w-100">
                <div className="col-12 d-flex justify-content-end mb-0">
                  <BaseButton
                    type="submit"
                    label={submitLabel}
                    color="success"
                    loader={btnLoader}
                    disable={btnLoader}
                  />
                </div>
              </div>

              <DeleteModal
                show={deleteModal}
                onCloseClick={closeDeleteModal}
                onDeleteClick={handleDeleteConfirmation}
                btnLoader={btnLoader}
              />
            </form>
          </div>
          <BaseModal
            open={makeModal}
            toggle={() => {
              setMakeModal(!makeModal);
              makeForm.resetForm();
            }}
            submit={() => makeForm.handleSubmit()}
            title={addMakeLabel}
            closeLabel={NoLabel}
            submitLabel={YesLabel}
            closeLabelColor="danger"
            submitLabelColor="success"
            loader={modalLoader}
            size="sm"
          >
            <div className="form-group">
              <BaseInput
                type="text"
                label={MAKE_NAME}
                placeholder={InputPlaceHolder(MAKE_NAME)}
                name="name"
                className="form-control"
                value={makeForm.values.name}
                onChange={makeForm.handleChange}
                handleBlur={makeForm.handleBlur}
                touched={makeForm.touched.name}
                error={makeForm.errors.name}
                required
              />
            </div>
          </BaseModal>
        </div>
      </div>
    </div>
  );
};

export default PartRequisition;
